module.exports = __webpack_public_path__ + "static/media/icon-shown-completed.0dbe9886.svg";